import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';
import { ScheduleEducationPlans } from 'features/schedule-education-plans';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Расписание на неделю',
    url: '',
  },
];

export const ScheduleForWeekPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Расписание на неделю">
      <ScheduleEducationPlans />
    </AppPage>
  );
};
